export const STATUS_NAME_PENDIENTE_DE_OFERTAR = 'Pendiente de ofertar'
export const STATUS_NAME_A_GESTIONAR_POR_CARMUV = 'A gestionar por Carmuv'
export const STATUS_NAME_EN_GESTION = 'En gestión'
export const STATUS_NAME_NO_ADMITIDA = 'Compra No admitida'
export const STATUS_NAME_MINORISTAS = 'Confirmado en Minoristas'
export const STATUS_NAME_POR_INGRESAR = 'Por ingresar'
export const STATUS_NAME_FINALIZADO_RECHAZADO = 'Finalizado Rechazado'

export const STATUS_ID_PENDIENTE_DE_OFERTAR = '11'
export const STATUS_ID_COMPRA_ACEPTADA = '8'
export const STATUS_ID_COMPRA_RECHAZADA = '10'
export const STATUS_ID_EN_GESTION = '7'
export const STATUS_ID_PASE_ACEPTADO = '9'
export const STATUS_ID_OFERTADO = '12'
export const STATUS_ID_VENDIDO = '13'
export const STATUS_ID_COBRADO = '14'

export const INGRESADO_ID = '2'
export const MINORISTAS_ID = '3'
export const RECHAZADOS_ID = '4'
export const CARMUV_ID = ['5', '8', '9']
export const NO_ADMITIDOS_ID = '10'

export const CONFIRMAR_MINORISTAS = 'Confirmar en Minoristas'
export const CAMBIAR_MINORISTAS = 'Cambiar a Minoristas'
export const CONFIRMAR_RECHAZADOS = 'Confirmar en Rechazados'
export const CAMBIAR_RECHAZADOS = 'Cambiar a Rechazados'
export const CONFIRMAR_CARMUV = 'Confirmar en Carmuv'
export const CAMBIAR_CARMUV = 'Cambiar a Carmuv'
export const FINALIZAR_PROCESO_VENTA = 'Finalizar el proceso de venta'
export const FINALIZAR = 'Finalizar'
